import { render, staticRenderFns } from "./WithdrawFunds.vue?vue&type=template&id=54015dcf"
import script from "./WithdrawFunds.vue?vue&type=script&lang=js"
export * from "./WithdrawFunds.vue?vue&type=script&lang=js"
import style0 from "./WithdrawFunds.vue?vue&type=style&index=0&id=54015dcf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports